export default __webpack_public_path__ + "static/media/Zeeshan.2b420469.mp4";